function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* eslint-disable max-len */
import React from 'react';
import withCssProps from '../../../hocs/withCssProps';
import { StyledIcon } from './StyledIcon';
export var IchatOnline = withCssProps(function (props) {
  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2569 2H4.33945C3.04963 2 2 3.04963 2 4.33945V16.0367C2 16.3174 2.15128 16.5771 2.39537 16.7151C2.51468 16.783 2.64725 16.8165 2.77982 16.8165C2.91862 16.8165 3.05743 16.7799 3.18142 16.705L6.70931 14.5886C6.83096 14.5153 6.96977 14.4771 7.11092 14.4771H15.2569C16.5467 14.4771 17.5963 13.4274 17.5963 12.1376V4.33945C17.5963 3.04963 16.5467 2 15.2569 2Z",
    fill: "#495057"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00037 16.6776H17.4577C18.7475 16.6776 19.7971 15.6279 19.7971 14.3381V7H20.2572C21.5471 7 22.5967 8.04963 22.5967 9.33945V21.0367C22.5967 21.3174 22.4454 21.5771 22.2013 21.7151C22.082 21.783 21.9495 21.8165 21.8169 21.8165C21.6781 21.8165 21.5393 21.7799 21.4153 21.705L17.8874 19.5886C17.7657 19.5153 17.6269 19.4771 17.4858 19.4771H9.33982C8.05 19.4771 7.00037 18.4274 7.00037 17.1376V16.6776ZM9.33982 7H7.00037L7 16.6776H7.00037V9.33945C7.00037 8.04963 8.05 7 9.33982 7Z",
    fill: "#495057"
  }));
});